import { Button, Grid, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { enUS, pl } from "date-fns/locale";
import { useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGE_KEY_IN_LOCAL_STORAGE } from "../../../helpers/constants";
import useLocalStorage from "../../../hooks/useLocalStorage";
import BasicDialog from "../../base/BasicDialog";
import { EmailBodyEditor } from "./EmailBodyEditor";
import { EmailRecipients } from "./EmailRecipients";
import { EmailSubjectInput } from "./EmailSubjectInput";

export const SendEmailDialog = (props) => {
    const {
        onClose,
        recipientEmails,
        initialSubject = "",
        initialBody = "",
        onSendEmail,
        title,
        disableSend = false,
        showDueDateField = false,
        initialDueDate = null,
        readOnly= false,
        isDueDateRequired = false,
    } = props;
    const { t } = useTranslation();

    const [subject, setSubject] = useState(initialSubject);
    const [dueDate, setDueDate] = useState(initialDueDate ? new Date(initialDueDate) : null);
    const bodyRef = useRef(null);

    const [language, _] = useLocalStorage(LANGUAGE_KEY_IN_LOCAL_STORAGE, "pl");

    const handleSend = useCallback(() => {
        if (isDueDateRequired && !dueDate) return

        const body = bodyRef.current?.getHtml() || "";
        const dueDateString = dueDate ? dueDate.toISOString().split("T")[0] : null;
        onSendEmail(subject, body, showDueDateField ? dueDateString : undefined);
        onClose();
    }, [bodyRef, subject, dueDate, onSendEmail, onClose, showDueDateField, isDueDateRequired]);

    return (
        <BasicDialog
            open={props.open}
            onClose={onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            title={title || t("SendEmailDialog.title")}
            minWidth={800}
            maxWidth={"xl"}
            showDialogActions
        >
            <Grid container spacing={2} direction="column">
                <Grid item xs={12}>
                    <EmailRecipients emails={recipientEmails} />
                </Grid>
                <Grid item xs={12}>
                    <EmailSubjectInput value={subject} onChange={setSubject} readOnly={readOnly}/>
                </Grid>
                {showDueDateField && (
                    <Grid item xs={12}>
                        <LocalizationProvider
                            dateAdapter={AdapterDateFns}
                            adapterLocale={language === "pl" ? pl : enUS}
                        >
                            <DatePicker
                                label={t("SendEmailDialog.dueDate")}
                                value={dueDate}
                                onChange={(newValue) => setDueDate(newValue)}
                                readOnly={readOnly}
                                inputFormat="dd/MM/yyyy"
                                renderInput={(params) => <TextField {...params} fullWidth disabled={readOnly} error={isDueDateRequired && !dueDate}/>
                            }
                            />
                        </LocalizationProvider>
                    </Grid>
                )}
                <Grid item xs={12} textAlign={"left"}>
                    <EmailBodyEditor ref={bodyRef} initialText={initialBody} readOnly={readOnly}/>
                </Grid>
                {!readOnly && <Grid item xs={12}>
                    <Button onClick={() => handleSend()} disabled={disableSend}>
                        {t("SendEmailDialog.send")}
                    </Button>
                </Grid>}
            </Grid>
        </BasicDialog>
    );
};
